import {
    TreatmentFileKind,
    TreatmentFileTypeEnum,
} from '../treatment-file.model';

export interface RequiredDesignFileInspectionMissingFile {
    readonly key: string;
    readonly label: string;
    readonly fileType: TreatmentFileTypeEnum | number;
    readonly fileKind: TreatmentFileKind;
    readonly source: string;
    readonly expectedFileExtension?: string | null;
}

export interface RequiredDesignFileInspection {
    readonly treatmentId: string;
    readonly designId: number;
    readonly templateId?: number | null;
    readonly templateName?: string | null;
    readonly hasMatchedTemplate: boolean;
    readonly hasMissingRequiredFiles: boolean;
    readonly missingRequiredDoctorDeliveryFiles: ReadonlyArray<RequiredDesignFileInspectionMissingFile>;
}
